import { useParams, Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import PageSEO from '@/components/base/PageSEO';

const articleImages: Record<string, string> = {
  'tiktok-game-ad-optimization-2026': 'https://readdy.ai/api/search-image?query=Modern%20mobile%20phone%20displaying%20colorful%20casual%20mobile%20game%20with%20TikTok%20style%20creative%20video%20ads%20floating%20around%2C%20tech%20marketing%20office%20background%20with%20warm%20ambient%20lighting%2C%20editorial%20photography%20style%2C%20clean%20composition%2C%20soft%20shadows%2C%20professional%20product%20shot&width=1200&height=600&seq=article-tiktok-2026&orientation=landscape',
  'game-ua-data-attribution-2026': 'https://readdy.ai/api/search-image?query=Abstract%20data%20analytics%20dashboard%20with%20colorful%20charts%20and%20graphs%20showing%20marketing%20attribution%20models%2C%20modern%20minimalist%20office%20workspace%20with%20multiple%20monitors%2C%20warm%20amber%20accent%20lighting%2C%20professional%20tech%20environment%2C%20clean%20and%20bright%20composition&width=1200&height=600&seq=article-data-attribution&orientation=landscape',
  'playable-ads-design-trends-2026': 'https://readdy.ai/api/search-image?query=Creative%20mobile%20game%20playable%20ad%20design%20concept%20with%20interactive%20game%20elements%20floating%20on%20smartphone%20screen%2C%20colorful%20casual%20game%20art%20style%2C%20modern%20creative%20studio%20background%20with%20warm%20lighting%2C%20professional%20product%20photography&width=1200&height=600&seq=article-playable-ads&orientation=landscape',
  'southeast-asia-game-market-2026': 'https://readdy.ai/api/search-image?query=Southeast%20Asia%20cityscape%20with%20digital%20game%20elements%20overlay%2C%20colorful%20neon%20lights%20reflecting%20modern%20gaming%20culture%2C%20warm%20sunset%20skyline%20of%20Bangkok%20and%20Jakarta%2C%20tech%20style%20illustration%2C%20vibrant%20and%20dynamic%20composition&width=1200&height=600&seq=article-sea-market&orientation=landscape',
  'slg-game-global-ua-case-study': 'https://readdy.ai/api/search-image?query=Medieval%20strategy%20game%20art%20with%20castle%20siege%20scene%2C%20dramatic%20lighting%20with%20warm%20golden%20accents%2C%20professional%20game%20concept%20art%20style%2C%20dark%20moody%20atmosphere%20with%20fire%20and%20battle%20elements%2C%20epic%20fantasy%20composition&width=1200&height=600&seq=article-slg-case&orientation=landscape',
  'google-ads-game-campaign-2026': 'https://readdy.ai/api/search-image?query=Google%20Ads%20dashboard%20interface%20on%20modern%20desktop%20monitor%2C%20colorful%20data%20charts%20and%20campaign%20metrics%2C%20warm%20office%20environment%20with%20natural%20light%2C%20professional%20digital%20marketing%20workspace%2C%20clean%20tech%20aesthetic&width=1200&height=600&seq=article-google-ads&orientation=landscape',
  'game-aso-strategy-2026': 'https://readdy.ai/api/search-image?query=App%20Store%20and%20Google%20Play%20store%20listings%20displayed%20on%20smartphone%20screens%2C%20colorful%20game%20icons%20and%20screenshots%2C%20modern%20minimalist%20desk%20setup%20with%20warm%20lighting%2C%20professional%20app%20marketing%20concept%2C%20clean%20composition&width=1200&height=600&seq=article-aso&orientation=landscape',
  'game-creative-localization-guide': 'https://readdy.ai/api/search-image?query=Creative%20game%20advertising%20materials%20in%20multiple%20languages%20and%20cultural%20styles%20displayed%20on%20a%20modern%20designer%20desk%2C%20colorful%20mobile%20game%20art%20variations%2C%20warm%20creative%20studio%20lighting%2C%20professional%20multicultural%20marketing%20concept&width=1200&height=600&seq=article-localization&orientation=landscape',
  'casual-game-mena-market': 'https://readdy.ai/api/search-image?query=Modern%20Dubai%20skyline%20with%20futuristic%20digital%20game%20elements%20overlay%2C%20warm%20golden%20desert%20sunset%20colors%2C%20luxurious%20Middle%20East%20cityscape%2C%20tech%20and%20gaming%20culture%20fusion%2C%20vibrant%20professional%20illustration&width=1200&height=600&seq=article-mena-market&orientation=landscape',
  'game-rewarded-video-ads-guide': 'https://readdy.ai/api/search-image?query=Mobile%20game%20screen%20showing%20rewarded%20video%20ad%20interface%20with%20colorful%20rewards%2C%20casual%20game%20art%20style%2C%20modern%20smartphone%20display%2C%20warm%20and%20inviting%20game%20environment%2C%20clean%20UI%20design%20concept&width=1200&height=600&seq=article-rewarded-video&orientation=landscape',
};

export default function ArticleDetailPage() {
  const { slug } = useParams<{ slug: string }>();
  const article = articles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <>
        <PageSEO title="文章未找到 - 木瓜玩" description="文章不存在或已被移除" />
        <ScrollToTop />
        <Navbar />
        <main className="pt-16 min-h-[60vh] flex items-center justify-center">
          <div className="text-center">
            <h1 className="font-heading font-bold text-2xl text-foreground-950 mb-2">文章未找到</h1>
            <Link to="/articles" className="text-sm text-primary-600 hover:text-primary-700 cursor-pointer">
              返回行业洞察
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const relatedArticles = articles
    .filter((a) => a.slug !== article.slug && (a.categorySlug === article.categorySlug || a.featured))
    .slice(0, 3);

  return (
    <>
      <PageSEO
        title={`${article.title} - 木瓜玩游戏出海`}
        description={article.excerpt}
        keywords={article.tags.join(',')}
        canonicalUrl={`https://steamvip520.cn/articles/${article.slug}`}
        schemaJson={{
          "@context": "https://schema.org",
          "@type": "Article",
          "headline": article.title,
          "description": article.excerpt,
          "author": {
            "@type": "Person",
            "name": article.author
          },
          "datePublished": article.publishDate,
          "publisher": {
            "@type": "Organization",
            "name": "木瓜玩",
            "url": "https://steamvip520.cn/"
          },
          "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": `https://steamvip520.cn/articles/${article.slug}`
          }
        }}
      />
      <ScrollToTop />
      <Navbar />

      <main className="pt-16 md:pt-18">
        <article>
          <div className="px-6 md:px-10 py-8 md:py-10 bg-background-100">
            <div className="max-w-4xl mx-auto">
              <Breadcrumb
                items={[
                  { label: '首页', path: '/' },
                  { label: '行业洞察', path: '/articles' },
                  { label: article.title },
                ]}
              />

              <div className="mt-6">
                <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-4">
                  {article.category}
                </span>
                <h1 className="font-heading font-bold text-xl md:text-3xl lg:text-4xl text-foreground-950 leading-tight mb-4">
                  {article.title}
                </h1>
                <div className="flex flex-wrap items-center gap-4 text-xs md:text-sm text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-user-line"></i>
                    {article.author}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-calendar-line"></i>
                    {article.publishDate}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="px-6 md:px-10 py-8 md:py-10 bg-background-50">
            <div className="max-w-4xl mx-auto">
              <div className="rounded-lg overflow-hidden mb-10">
                <img
                  src={articleImages[article.slug] || ''}
                  alt={article.title}
                  title={`${article.title} - 木瓜玩特约文章`}
                  className="w-full object-cover object-top max-h-[400px]"
                />
              </div>

              <div
                className="prose prose-sm md:prose-base max-w-none
                  prose-headings:font-heading prose-headings:text-foreground-950 prose-headings:font-bold
                  prose-h2:text-lg md:prose-h2:text-xl prose-h2:mt-8 prose-h2:mb-4
                  prose-h3:text-base md:prose-h3:text-lg prose-h3:mt-6 prose-h3:mb-3
                  prose-p:text-foreground-700 prose-p:leading-relaxed prose-p:text-sm md:prose-p:text-base
                  prose-strong:text-foreground-900 prose-a:text-primary-600"
                dangerouslySetInnerHTML={{ __html: article.content }}
              />

              <div className="flex flex-wrap gap-2 mt-10 pt-8 border-t border-background-200">
                {article.tags.map((tag) => (
                  <span
                    key={tag}
                    className="px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full"
                  >
                    #{tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </article>

        {relatedArticles.length > 0 && (
          <section className="px-6 md:px-10 py-10 md:py-14 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <h2 className="font-heading font-bold text-lg md:text-2xl text-foreground-950 mb-6">
                相关文章
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {relatedArticles.map((rel) => (
                  <Link
                    key={rel.slug}
                    to={`/articles/${rel.slug}`}
                    className="group block bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
                  >
                    <div className="relative overflow-hidden h-40 md:h-44">
                      <img
                        src={articleImages[rel.slug] || ''}
                        alt={rel.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-4">
                      <span className="text-xs text-foreground-400">{rel.category}</span>
                      <h3 className="font-heading font-semibold text-sm text-foreground-950 mt-1 line-clamp-2 group-hover:text-primary-600 transition-colors">
                        {rel.title}
                      </h3>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        )}
      </main>

      <Footer />
    </>
  );
}